import { FormInstance, Row, Button, Flex } from "antd";
import FormSection from "../../../components/FormSection";
import { getCouponDateTimeBounds, getNow } from "../../../utils/DateFn";
import {
  formatDisplayDate,
  formatDisplayTime,
} from "../../../utils/DateAndTimeConvertor";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import DateTimePicker from "../../../components/DateTimePicker";
import dayjs from "../../../utils/dayjsConfig";

const ActiveDates = ({ form }: { form: FormInstance }) => {
  const event = useSelector((state: RootState) => state.event);
  const eventStartDate = event?.start_date as string | undefined;
  const eventEndDate = (event?.end_date || event?.start_date) as
    | string
    | undefined;
  const couponBounds = getCouponDateTimeBounds(event);

  return (
    <FormSection
      title="Coupon Duration"
      description="Coupon can start from today. The end date and time cannot be after the event ends."
      withoutCard
    >
      <>
        {couponBounds.maxDateTime && (
          <div
            style={{
              background: "#f9fafb",
              border: "1px solid #e5e7eb",
              borderRadius: 8,
              padding: "8px 12px",
              marginBottom: 16,
              fontSize: 12,
              color: "#6b7280",
            }}
          >
            <span style={{ fontWeight: 600, color: "#374151" }}>Event: </span>
            {event?.start_date ? formatDisplayDate(event.start_date) : ""}
            {event?.start_time
              ? `, ${formatDisplayTime(event.start_time, ["hh:mm A", "HH:mm:ss"])}`
              : ""}
            {eventStartDate && eventEndDate ? " — " : ""}
            {event?.end_date ? formatDisplayDate(event.end_date) : ""}
            {event?.end_time
              ? `, ${formatDisplayTime(event.end_time, ["hh:mm A", "HH:mm:ss"])}`
              : ""}
          </div>
        )}

        <Flex justify="flex-end" style={{ marginBottom: 16 }}>
          <Button
            size="small"
            onClick={() => {
              const now = getNow();
              const values: Record<string, unknown> = {
                start_date: now,
                start_time: now.format("hh:mm A"),
              };

              if (!form.getFieldValue("end_date") && eventEndDate) {
                values.end_date = dayjs(eventEndDate);
              }

              form.setFieldsValue(values);
              form
                .validateFields([
                  "start_date",
                  "start_time",
                  "end_date",
                  "end_time",
                  "_datetime_range_validator_start_date_start_time_end_date_end_time",
                ])
                .catch(() => undefined);
            }}
          >
            Set coupon start now
          </Button>
        </Flex>

        <Row gutter={[24, 0]}>
          <DateTimePicker
            form={form}
            label={["Start Date", "Start Time", "End Date", "End Time"]}
            name={["start_date", "start_time", "end_date", "end_time"]}
            disabledBasedOn={eventEndDate}
            bounds={couponBounds}
            minGapMinutes={0}
          />
        </Row>
      </>
    </FormSection>
  );
};

export default ActiveDates;
